document.addEventListener('DOMContentLoaded', function() {
  const jumpLinks = document.querySelectorAll('[data-jump-link]');
  if (!jumpLinks.length) return;

  jumpLinks.forEach(link => {
      link.addEventListener('click', function(event) {
          event.preventDefault();
          const targetId = new URL(this.href).hash;
          if (targetId) {
              const targetElement = document.querySelector(targetId);
              if (targetElement) {
                  targetElement.scrollIntoView({ behavior: 'smooth' });
              }
          }
      });
  });
});
